import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-emerald-500/15',
    borderColor: 'border-emerald-500/40',
    textColor: 'text-emerald-300',
    emoji: '🟢',
    title: 'Semillas',
    subtitle: '0 a 12 meses · La base de todo',
    desc: 'El primer año de vida es el más importante del desarrollo neurológico. Reflejos del recién nacido, Tummy Time semana a semana, actividades de alto contraste, masaje infantil, gateo, pinza fina, BLW sensorial desde los 6 meses y checklist de hitos mes a mes.'
  }, {
    id: 2,
    lightColor: 'bg-yellow-500/15',
    borderColor: 'border-yellow-500/40',
    textColor: 'text-yellow-300',
    emoji: '🟡',
    title: 'Pasos',
    subtitle: '12 a 24 meses · El gran salto',
    desc: 'La etapa donde todo explota: la marcha, el lenguaje, la autonomía y los primeros "no". Desarrollo de la marcha, explosión del lenguaje, juego simbólico inicial, manejo de rabietas, primeros límites y autonomía temprana en vestido, alimentación y orden.'
  }, {
    id: 3,
    lightColor: 'bg-orange-500/15',
    borderColor: 'border-orange-500/40',
    textColor: 'text-orange-300',
    emoji: '🟠',
    title: 'Exploradores',
    subtitle: '2 a 3 años · La imaginación toma el control',
    desc: 'El mundo se convierte en un laboratorio. Lenguaje complejo (frases de 3+ palabras), juego dramático y de roles, grafomotricidad inicial, ciencia simple con materiales del hogar, conteo real, regulación emocional y 30 actividades listas para usar.'
  }, {
    id: 4,
    lightColor: 'bg-sky-500/15',
    borderColor: 'border-sky-400/40',
    textColor: 'text-sky-300',
    emoji: '🔵',
    title: 'Creadores',
    subtitle: '3 a 4 años · El pensamiento se organiza',
    desc: 'Tu hijo empieza a clasificar, comparar y crear reglas propias. Control de trazo y pre-escritura, clasificación y lógica simple, pensamiento secuencial, juego grupal guiado, creatividad plástica, musical y dramática, y autonomía en baño y alimentación.'
  }, {
    id: 5,
    lightColor: 'bg-purple-500/15',
    borderColor: 'border-purple-500/40',
    textColor: 'text-purple-300',
    emoji: '🟣',
    title: 'Proyectores',
    subtitle: '4 a 5 años · La puerta a la escuela',
    desc: 'Todo lo que necesita para entrar al jardín con seguridad y herramientas reales. Pre-lectoescritura sin presión, lateralidad y dominancia manual, conciencia fonológica, gestión emocional, autonomía escolar y checklist de madurez escolar.'
  }, {
    id: 6,
    lightColor: 'bg-amber-500/15',
    borderColor: 'border-amber-500/40',
    textColor: 'text-amber-300',
    emoji: '⭐',
    title: 'Preparación',
    subtitle: '5 a 6 años · El gran salto al primer grado',
    desc: 'El cierre del ciclo inicial. Lectoescritura avanzada sin presión, razonamiento matemático concreto, resolución de problemas, madurez emocional y social para primer grado, autonomía plena y evaluación de madurez escolar completa.'
  }];
  return <section className="py-20 bg-sky-900" data-id="element-325">
      <div className="container mx-auto px-4" data-id="element-326">
        <div className="text-center mb-16" data-id="element-327">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sky-400/20 text-sky-200 border border-sky-400/30 font-bold mb-6 text-[16px]" data-id="element-328">
            🌱 MEGAPACK ESTIMULACIÓN TEMPRANA LISTO
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-329">
            6 Tomos + 4 Bonos
          </h2>
          <p className="text-sky-100 font-medium text-[16px]" data-id="element-330">
            De la incertidumbre al desarrollo con sistema. 360+ páginas — Todo
            resuelto.
          </p>
          <p className="text-sky-300 font-medium text-sm mt-2" data-id="element-331">
            📚 Un tomo por cada etapa de tu hijo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-332">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-sky-800 bg-sky-950/70 overflow-hidden shadow-lg hover:shadow-xl hover:border-sky-700 transition-all flex flex-col h-full" data-id="element-333">
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-334">
                <div className="text-2xl" data-id="element-335">{tomo.emoji}</div>
                <div data-id="element-336">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-337">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-338">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-339">
                <p className="font-semibold text-sky-200 mb-3 pb-3 border-b border-sky-800/60" data-id="element-340">
                  {tomo.subtitle}
                </p>
                <p className="text-sky-100 text-sm leading-relaxed" data-id="element-341">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}